<template>
  <div class="multiterm_text_question">    
    <div class="qes_txt" :style="{'color':surveyTheme.bodyColor}">
      <i class="qes_num" v-if="surveyTheme.openCode">{{data.showNum}}.</i>
      <div class="qes_name" v-html="data.qesName"></div>
    </div>
    <div class="answers">
      <div class="answer_item" v-for="item in data.subQes" :key="item.qesId">
        <div class="sub_item">
          <div class="sub_qes_name" v-html="item.qesName"></div>
          <input class="sub_answer" @blur="selectAnswer()" v-model="item.ansContent" placeholder="请输入" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

 export default {
   components: { 
    
  },
  props: ['data','currentPage','index'],
  watch: {  
    // 'data'(){
    //   console.log('单行文本题data值变了',this.data);
    //   if(this.data.showSelected){
    //     this.showSelected = this.data.showSelected;
    //     console.log('有值',this.showSelected);
    //   }else{
    //     console.log('没有值');
    //   }
    // }
    'data'(a,b){
      console.log(a,b);
    }
  },
  data(){
    return {
      surveyTheme:{},                         //问卷主题
      showSelected:[],                        //已选答案ID       (前端回显用)
      selectData:[],                          //已选答案相关对象 (提交后台用)
    }
  },
  created(){
    this.data.qesName = this.data.qesName.replaceAll('\n','<br/>');
    this.showSelected = this.data.showSelected;
    this.surveyTheme = JSON.parse(sessionStorage.getItem("surveyTheme"));
    // console.log(this.surveyTheme);
    // console.log('多项短文本题data',this.data);
    this.data.subQes.forEach(item=>{
      item.ansContent = item.ansContent ? item.ansContent : '';
    });
  },
  methods:{
    selectAnswer(){
      // console.log(this.showSelected);
      this.data.showSelected = this.showSelected;
      let obj = {};
      // obj.ansName = this.showSelected;
      obj.qesId = this.data.qesId;
      obj.surveyId = this.data.surveyId;
      obj.qesType = this.data.qesType;
      obj.otherType = this.data.otherType;
      obj.groId = this.data.groId;
      obj.qesName = this.data.qesName;
      obj.qesNum = this.data.qesNum;
      obj.qesOrder = this.data.qesOrder;
      obj.subQes = [];
      // 子问题对象
      this.data.subQes.forEach(item=>{
        let subObj = {};
        subObj.qesId = item.qesId;
        subObj.qesName = item.qesName;
        subObj.ansContent = item.ansContent;
        obj.subQes.push(subObj);
      });
      obj.subQes = JSON.stringify(obj.subQes)
      this.selectData.gIndex = this.currentPage - 1;
      this.selectData.qIndex = this.index;
      this.selectData.submitQesObj = obj;
      // console.log(this.selectData);
      this.$emit("sendAnswer",this.selectData);
    }
  }
}
</script>
<style lang="less" scoped>
  .multiterm_text_question{
    background-color: transparent;
    width: 100%;
    padding: 60px 40px;
    box-sizing: border-box;
    .qes_txt{
      margin-bottom: 40px;
      font-size: 36px;
      color: #333;
      line-height: 56px;
      display: flex;
      align-items: center;
      .qes_num{
        font-size: 34px;
        // line-height: 65px;
        margin-right: 10px;
      }
      .qes_name{
        font-size: 36px;
        display: inline;
        word-break: break-all;
      }
    }
    .answers{
      width: 100%;
      .answer_item{
        margin-bottom: 40px;
        .sub_item{
          .sub_qes_name{
            padding: 0 6px 14px;
            box-sizing: border-box;
            font-size: 32px;
            color: #333;
            line-height: 45px;
          }
          .sub_answer{
            width: 85%;
            height: 43px;
            padding: 15px 20px;
            font-size: 28px;
            border: 1px solid #f3eded;
            border-radius: 6px;
            color: #333;
            background-color: #fbfbfb;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/textQuestion/multitermTextQuestion.vue